module.exports = __webpack_public_path__ + "static/img/3-4.94ef230f.png";